import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {
  ThemeProvider,
  Toastr,
  TooltipProvider
} from '@sparrowengg/twigs-react';
import { useSelector } from 'react-redux';
import AuthenticateUser from 'features/auth';
import Cookies from 'universal-cookie';
import { useDispatch } from 'react-redux';
import { setIsUserLoggedIn } from 'redux-store/actions';
import AddAppsPage from 'pages/add-apps';
import DashboardPage from 'pages/dashboard';
import EditAppPage from 'pages/edit-app';
import FallbackPage from 'pages/fallback';
import { IRootDispatch, IRootState } from 'commons/types';
import { authenticateUserValues } from 'commons/constants';
import { sparrowLaunch } from 'commons/services';
import AddWebhookPage from 'pages/add-webhook';
import CodeEditorPage from 'pages/code-editor';
import AddLocalDevAppPage from 'pages/add-local-dev-app';
import EditLocalDevAppPage from 'pages/edit-local-dev-app';
import AppStoragePage from './pages/app-storage';
import DocumentationPage from './pages/documentation';
import './commons/styles/index.css';

function App() {
  const dispatch: IRootDispatch = useDispatch();
  const userLoggedIn = useSelector((state: IRootState) => state.userLoggedIn);

  useEffect(() => {
    const cookie = new Cookies();
    if (cookie.get(authenticateUserValues.TOKEN)) {
      dispatch(setIsUserLoggedIn(true));
    }
    sparrowLaunch({
      page: window.location.href
    });
  }, []);

  return (
    <ThemeProvider
      theme={{
        fonts: {
          body: "'DM sans', sans-serif",
          heading: "'DM sans', sans-serif"
        }
      }}
    >
      <Toastr duration={1500} />
      <TooltipProvider delayDuration={0}>
        <Router>
          <Routes>
            {userLoggedIn ? (
              <>
                <Route path="/" element={<DashboardPage />} />
                <Route path="/add-apps" element={<AddAppsPage />} />
                <Route path="/add-webhook" element={<AddWebhookPage />} />
                <Route path="/edit-app/:id" element={<EditAppPage />} />
                <Route path="/code-editor/" element={<CodeEditorPage />} />
                <Route
                  path="/add-local-dev-app"
                  element={<AddLocalDevAppPage />}
                />
                <Route
                  path="/edit-local-dev-app/:id"
                  element={<EditLocalDevAppPage />}
                />
                <Route
                  path="/edit-local-dev-app/:id/appFeatureUsage"
                  element={<AppStoragePage />}
                />
                <Route path="/documentation" element={<DocumentationPage />} />
              </>
            ) : (
              <Route
                path="/developer-portal-redirect"
                element={<AuthenticateUser />}
              />
            )}
            <Route path="*" element={<FallbackPage />} />
          </Routes>
        </Router>
      </TooltipProvider>
      {/* Survey Sparrow Embedded Chat Survey */}
      <div id="ss_survey_widget" style={{ cursor: 'pointer' }}></div>
    </ThemeProvider>
  );
}

export default App;
